
/* eslint-disable react/prop-types */
import React from 'react';
import {
  Box,
  Typography,
  Tooltip
} from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CustomCircularProgress from '../../../common/CustomCircularProgress ';
import { useAssignmentsDetailsStyles } from './styles/AssignmentSectionStyles';


const TaskBox = ({
  title,
  dueText,
  percentComplete,
  assignmentComplete,
  isSelected = false
}) => {
  const classes = useAssignmentsDetailsStyles({ isSelected });

  return (
    <Box className={classes.root} style={{ border: isSelected ? '2px solid #3D1788' : 'none' }}>
      <Box style={{ display: 'flex', flexDirection: 'row', gap: 20 }}>
        <Box
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <CustomCircularProgress
            radius={30}
            color="#512EAB"
            incompleteColor="#d0d0ff"
            borderWidth={3}
            value={percentComplete}
          >
            <Typography variant="caption" style={{ fontSize: 14, color: 'black' }}>
              {`${percentComplete}%`}
            </Typography>
          </CustomCircularProgress>
        </Box>
        <Box style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
          <Box style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%' }}>
            <Typography variant="h6" component="h6">
              {title}
            </Typography>
            <Typography variant="body2" className={classes.percentText}>{dueText}</Typography>
          </Box>
          <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            {assignmentComplete && (
            <Tooltip title={assignmentComplete ? 'Completed' : dueText}>
              <CheckCircleIcon fontSize="small" style={{ color: 'green', width: 18, height: 18 }} />
            </Tooltip>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TaskBox;
